import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrAutoSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_auto_select"}/>
}
